<template>
<span>
<pazar-standard-hero></pazar-standard-hero>
<pazar-standard-details></pazar-standard-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PageFooter from '@/components/PageFooter';
import PazarStandardHero from '@/components/PazarStandardHero';
import PazarStandardDetails from '@/components/PazarStandardDetails';
export default {
    name :'pazarsherkati',
    components:{
     PazarStandardHero,
     PazarStandardDetails,
        PageFooter
    }

    
};
</script>


